import React from "react";
import { useToast } from "@chakra-ui/react";
import * as Sentry from "@sentry/react";

export const Context = React.createContext(undefined);

export default function ContextWrapper({ profile, children }) {
  const toast = useToast();
  const fireToast = (title, description, status) => {
    toast({
      title: title,
      description: description,
      status: status,
      duration: 5000,
      isClosable: true,
      position: "top",
    });
  };

  // Update Sentry user context when profile changes
  React.useEffect(() => {
    if (profile && profile.id) {
      Sentry.setUser({
        id: profile.id,
        email: profile.email,
        user_type: profile.user_type,
      });
    } else {
      // Clear user context on logout or when profile is not available
      Sentry.setUser(null);
    }
  }, [profile]);

  return (
    <Context.Provider value={{ fireToast, profile }}>
      {children}
    </Context.Provider>
  );
}

export const useCurrentProfile = () => React.useContext(Context);
